import {
  Box,
  Divider,
  Icon,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { landingPageRoutes } from "../../routes";
import { useLocation, useNavigate } from "react-router-dom";
import appcolors from "../../constants/Colors";

const CustomDrawer = ({ handleDrawerToggle }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <Box onClick={handleDrawerToggle}>
      <Typography variant="h6" sx={{ m: 2 }}>
        LOBA LOGA
      </Typography>
      <Divider />
      <List>
        {landingPageRoutes.map((item, index) => {
          const isMatched = pathname == item.path;
          return (
            <ListItem
              key={index}
              disablePadding
              sx={{ backgroundColor: isMatched ? appcolors.primary : null }}
            >
              <ListItemButton onClick={() => navigate(item.path)}>
                <ListItemIcon>
                  <Icon
                    sx={{
                      color: isMatched ? "#ffffff" : null,
                      fontSize: "2rem",
                    }}
                  >
                    {item.icon}
                  </Icon>
                </ListItemIcon>
                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontWeight: 500,
                      color: isMatched ? "#ffffff" : "#000000",
                    },
                  }}
                  primary={item.name}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default CustomDrawer;
